"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoryCache = () => {
    const memoryCacheBucket = {};
    const set = (key, value) => {
        memoryCacheBucket[key] = value;
    };
    const get = (key) => {
        if (memoryCacheBucket.hasOwnProperty(key)) {
            return memoryCacheBucket[key];
        }
    };
    return {
        set,
        get
    };
};



//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/utils/memory-cache.js
// module id = 1533
// module chunks = 13 14